export default __webpack_public_path__ + "testimonial-section.png";